export default __webpack_public_path__ + "static/media/instagram.d81bb07c.svg";